var _style, _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#848484;}\n\t.st1{fill:#972679;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 178.8,
    cy: 198.8,
    r: 14.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.6,70.7H410c4.8,17.2,20.5,29.7,39.3,29.7c22.5,0,40.8-18.3,40.8-40.8s-18.3-40.8-40.8-40.8 c-18.7,0-34.4,12.6-39.3,29.7h-18.3c-6.1,0-11,4.9-11,11C380.6,65.7,385.5,70.7,391.6,70.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.8,104.7c-10.6,0-20,5.1-26,12.9c-3.2,3.7-14.3,15.7-29,20.2c-16,4.9-32.2-3.5-32.3-3.6 c-6.9-3.8-15.6-1.2-19.4,5.8s-0.9,15.1,5.8,19.4c13.9,9,41.8,9.6,54.3,5.8c5-1.5,9.7-3.6,14-5.9V229c0,10.5,5,19.9,12.6,25.8v127.9 c0,11.1,9,20,20.1,20s20.1-9,20.1-20V254.8c7.7-6,12.6-15.3,12.6-25.8v-91.5C482.5,119.3,467.9,104.7,449.8,104.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.4,178.8c-47.6,3.8-69.4-21.5-58.5-43c4.2-8.2,12.9-13.2,22.1-13.2c11.3,0,15.3,6.2,26.1,6.2 c6.1,0,13.2-2.2,13.2-5.4v-23.2c0-8.1-6.6-14.7-14.7-14.7h-42.1v19.1c0,1.4-1.1,2.5-2.5,2.5h-12c-1.4,0-2.5-1.1-2.5-2.5V85.5h-42.1 c-8.1,0-14.7,6.6-14.7,14.7v101.2c0,8.1,6.6,14.7,14.7,14.7h101.2c8.1,0,14.7-6.6,14.7-14.7v-20.2c0-0.7-0.3-1.4-0.9-1.9 C392.8,178.9,392.1,178.7,391.4,178.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.3,344.7H236V16.8c0-8.3-6.7-15-15-15H45.6c-8.3,0-15,6.7-15,15v328H10.3c-5.5,0-10,4.5-10,10v35.5 c0,5.5,4.5,10,10,10h246.1c5.5,0,10-4.5,10-10v-35.5C266.4,349.2,261.9,344.7,256.3,344.7z M206,344.8H60.7V31.9H206L206,344.8 L206,344.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.059e6a57f810c93b0b8c021a67e635b5.svg";
export { ForwardRef as ReactComponent };